import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../common/Breadcrumb";
import ProjectProcess from "./ProjectProcess";
// import ReletedProject from "./ReletedProject";

function ProjectDetailsPage() {
  const { projectName } = useParams();

  const formatName = (name) => {
    if (!name) return "Project Details";
    return name
      .replace(/-/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <>
      <Breadcrumb pageName={formatName(projectName)} />

      <div className="project-details-area sec-mar">
        <div className="container">
          <ProjectProcess projectName={projectName} />
          {/* <ReletedProject /> */}
        </div>
      </div>
    </>
  );
}

export default ProjectDetailsPage;